import React, { useState, useEffect, useRef } from 'react'
import Navbar from '../components/Navbar';
import AlertOnLoading from '../components/AlertOnLoading';
import Footer from '../components/Footer';
import { UserAuth } from '../App';
import { Toaster } from 'react-hot-toast';
import { collection, getDocs } from "firebase/firestore";
import { database } from "../config/firebaseConfig";

function Tests() {
    const WAIT_TIME = 2000;
    const {user} = UserAuth();
    const notInitialRender = useRef(false);

    const [newData, setNewData] = useState(true);
    const [results, setResults] = useState(null);

    const getMaxProducts = (width) => {
        if (width>= 640) {
          return 10;
        }
    
        return 5;
    }

    const [currentPage, setCurrentPage] = useState(1);
    const [resultsPerPages, setResultsPerPages] = useState(getMaxProducts(window.innerWidth));
    const lastResultIndex = currentPage * resultsPerPages;
    const firstResultIndex = lastResultIndex - resultsPerPages;

    function openResult(resultURL) {
        window.open(resultURL);
    }

    useEffect(() => {
        if (notInitialRender.current && newData) {
            AlertOnLoading(WAIT_TIME+100);
        } else {
            notInitialRender.current = true;
        }
        const interval = setInterval(() => { //Autorize re-render
            if (newData) {
                const resultsRef = collection(database, "users", user.id, "results");
                
                const getResults = async() => {
                    const data = await getDocs(resultsRef);
                    setResults(data.docs.map((doc) => ({...doc.data(), id: doc.id})));
                }
                getResults();
                setNewData(!newData);
                }
            }, WAIT_TIME);
            return () => clearInterval(interval);
      }, [results, newData, user.id])

    return (
        <div>
            
            <div>
            <Toaster
            toastOptions={{
                duration:3000,
            }}/>
            </div>

            <Navbar activePage={"/Tests"} />
            <div className='w-full h-navbar-mobile sm:h-navbar'></div>

            <div className='w-full h-96 bg-tests-banner bg-white'>

                <div className='h-full w-full bg-gradient-radial from-primary-100'>
                    <h2 className='text-white text-center py-44 text-3xl font-semibold sm:text-4xl'>Tus resultados a la mano</h2>  
                </div>

            </div>

            <div className='w-full h-auto bg-white my-6'>
                <div className='px-4 py-6 flex flex-col w-full h-0 bg-white lg:py-8'>
                    <h2 className='lg:text-xl'>Historial de exámenes</h2>
                    <span className='lg:w-80 w-48 border border-primary-100'></span>
                </div>
            
            
                <div className=''>
                    <div className="sm:flex sm:flex-col sm:px-10 sm:w-full sm:justify-center sm:items-center bg-white py-6">

                        <div className={`sm:flex sm:flex-col sm:w-full sm:space-y-1 sm:justify-center ${results? "sm:border sm:border-primary-100": "border-none"} p-1 sm:max-w-table-web`}>

                            <div className={`${results? "hidden w-full  sm:flex flex-row space-x-1":"hidden" }`}>


                                <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                                    <h3 className={`text-sm text-primary-100 lg:text-xl form1:text-xl`}>Motivo</h3>
                                </div>

                                <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                                    <h3 className={`text-sm text-primary-100 lg:text-xl form1:text-xl`}>Fecha</h3>
                                </div>

                                <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                                    <h3 className={`text-sm text-primary-100 lg:text-xl form1:text-xl`}>Acción</h3>
                                </div>
                            </div>

                            {results? results.slice(firstResultIndex, lastResultIndex).map((result, index)=> (
                            <div key={index}>
                                <div className="hidden w-full sm:flex flex-row space-x-1">

                                    <div className="flex justify-center items-center w-full h-8 bg-background">
                                        <h3 className="text-sm text-navFont-100 lg:text-xl form1:text-xl">{result.name}</h3>
                                    </div>

                                    <div className="flex justify-center items-center w-full h-8 bg-background">
                                        <h3 className="text-sm text-navFont-100 lg:text-xl form1:text-xl">{result.creation_date}</h3>
                                    </div>

                                    <div className="space-x-0.5 flex justify-center items-center w-full h-8 bg-background">

                                        <div className='w-full h-9 flex justify-center items-center'>
                                            <button onClick={() => {openResult(result.file);}} className='w-full h-7 text-sm bg-primary-100 text-white rounded-md font-bold lg:text-sm form1:text-xl hover:bg-primary-200'>Resultado</button>
                                        </div>

                                    </div>

                                </div>

                                <div className="w-full mb-4 flex justify-center sm:hidden sm:w-auto sm:flex-col sm:border sm:border-primary-100 sm:max-w-table-web sm:justify-center form1:mx-80 lg:justify-center lg:mx-56 lg:max-w-table-web">
                                    
                                    <div className="flex flex-col space-y-1 border border-primary-100 p-1 justify-center w-4/5 h-auto sm:flex-row sm:space-y-0 sm:space-x-1 sm:w-full max-w-table-web sm:border-none">

                                        <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                                            <h3 className="text-sm text-primary-100">Motivo</h3>
                                        </div>

                                        <div className="flex justify-center items-center w-full h-8 bg-background sm:hidden">
                                            <h3 className="text-sm text-navFont-100">{result.name}</h3>
                                        </div>

                                        <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                                            <h3 className="text-sm text-primary-100">Fecha</h3>
                                        </div>

                                        <div className="flex justify-center items-center w-full h-8 bg-background sm:hidden">
                                            <h3 className="text-sm text-navFont-100">{result.creation_date}</h3>
                                        </div>

                                        <div className="flex justify-center items-center w-full h-8 bg-primary-300">
                                            <h3 className="text-sm text-primary-100">Acción</h3>
                                        </div>

                                        <div className='sm:hidden space-x-2 w-full h-8 flex justify-center items-center bg-background'>
                                            
                                            <div className='w-1/2 h-9 flex justify-center items-center'>
                                                <button onClick={() => {openResult(result.file);}} className='w-full h-7 text-sm bg-primary-100 text-white rounded-md font-bold hover:bg-primary-200'>Resultado</button>
                                            </div>

                                        </div>

                                    </div>
                                </div>

                            </div>
                            ))
                            :
                            <div className='w-full flex h-footer-height justify-center items-center text-4xl text-primary-100 space-x-1'>
                                <svg fill='none' className="w-14 h-14 animate-spin" viewBox="0 0 32 32" xmlns='http://www.w3.org/2000/svg'>
                                    <path clipRule='evenodd'
                                        d='M15.165 8.53a.5.5 0 01-.404.58A7 7 0 1023 16a.5.5 0 011 0 8 8 0 11-9.416-7.874.5.5 0 01.58.404z'
                                        fill='currentColor' fillRule='evenodd' />
                                </svg>
                                <div>
                                    Cargando...
                                </div>
                            </div>
                            }

                        </div>

                        <div className={`${results? "flex" : "hidden"} w-full items-center justify-evenly mt-5`}>
                            <span className={`text-sm text-gray-700`}>
                                Mostrando <span className="font-semibold text-gray-900">{lastResultIndex >= results?.length? results?.length:lastResultIndex}</span> de <span className="font-semibold text-gray-900">{results?.length}</span> resultados
                            </span>
                            <div className="inline-flex mt-2 xs:mt-0">
                                <button
                                    onClick={() => {setCurrentPage(currentPage - 1)}}
                                    className={`${currentPage === 1? "pointer-events-none bg-primary-300" : "text-white bg-primary-100 hover:bg-primary-200"} px-4 py-2 text-sm font-medium rounded-l`}>
                                    Anterior
                                </button>
                                <button 
                                    onClick={() => {setCurrentPage(currentPage + 1)}}
                                    
                                    className={`${lastResultIndex >= results?.length? "pointer-events-none bg-primary-300" : "text-white bg-primary-100 hover:bg-primary-200"} px-4 py-2 text-sm font-medium border-0 border-l border-white rounded-r`}>
                                    Siguiente
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Tests